var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"left-button-to":{ name: 'settings-network' },"left-button-icon-name":"back","title":_vm.$t('network.settings.new.title'),"header-fill":"light","fill":"neutral"}},[_c('AeCard',{attrs:{"fill":"maximum"}},[_c('NetworkAdd',{attrs:{"finally-to":{ name: 'settings-network' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }